import {
  Box,
  Button,
  Card,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';
import { Order } from '../../types/order';
import PaginationTable from '../common/paginationTable';
import HeadTable from '../common/sortTable/sortTable';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { getFieldByTitle } from '../../helpers/sortByTitle';
import TablesSearch from '../common/tablesSearch/tablesSearch';
import FilterComponent from '../common/tablesFilter/FilterList';
import { selectedFilterItems } from '../../helpers/filter';
import DateFilter from './DateFilter';
import { Dialog } from '@material-ui/core';
// import AddTickets from './AddTickets';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import ViewTickets from './ViewTickets';
import './index.css';
import RemoveItem from '../common/Remove/RemoveItem';
import { getDate } from '../../helpers/dateHelper';

interface Props {
  id: string;
  isShow: boolean;
  props: any;
}

interface ModalState {
  addTickets: boolean;
  viewTickets: boolean;
  removeOrder: boolean;
  isShow: boolean;
  orders: undefined | any;
  orderIds: undefined | Array<string>;
}

const UsersTab: FC<Props> = ({ id, isShow, props }) => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [state, setState] = useState({
    orders: Array<any>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: '_id',
    order: 'asc',
  });

  const [modal, setModal] = useState<ModalState>({
    addTickets: false,
    viewTickets: false,
    removeOrder: false,
    orders: undefined,
    orderIds: undefined,
    isShow: false,
  });

  const [dropdown, setDropdown] = useState({
    competition: false,
    product: false,
    draw: false,
  });

  const [filter, setFilter] = useState({
    competitions: [{ id: 'Dream home', title: 'Dream home', isActive: true }],
    selectedCompetitions: Array<string>(),
    searchField: '',
    startDate: new Date('2000-01-18T19:55:00.000+00:00'),
    endDate: new Date('2030-01-18T19:55:00.000+00:00'),
  });

  const [searchState, setSearchState] = useState({
    name: '',
  });

  useEffect(() => {
    getOrders(
      1,
      10,
      '_id',
      'asc',
      Array<string>(),
      '',
      '',
      filter.startDate,
      filter.endDate
    );
  }, []);

  const closeAddTicketsModal = () => {
    setModal({ ...modal, addTickets: false });
  };

  const closeViewTickets = () => {
    setModal({ ...modal, viewTickets: false });
  };

  const openAddTicketsModal = () => {
    setModal({ ...modal, addTickets: true });
  };

  const getOrders = async (
    page: number,
    perPage: number,
    field: string,
    order: string,
    competitions: Array<string>,
    searchString: string,
    searchField: string,
    startDate: Date,
    endDate: Date
  ) => {
    const orders = await dataProvider.getWeeklySubscriptionDrawUsers('', {
      id: props.id,
      pagination: { page: page, perPage: perPage },
      sort: { field: field, order: order },
      filter: {
        competitions: competitions,
        searchString: searchString,
        searchField: searchField,
        startDate: startDate,
        endDate: endDate,
      },
    });
    if (orders.data) {
      setState({
        ...state,
        orders: orders.data.orders,
        total: orders.data.allCount,
        page: page,
        perPage: perPage,
        field: field,
        order: order,
      });
    }
  };

  const applyDateFilter = () => {
    getOrders(
      state.page,
      state.perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const clearDateFilter = () => {
    setFilter({
      ...filter,
      startDate: new Date('2000-01-18T19:55:00.000+00:00'),
      endDate: new Date('2030-01-18T19:55:00.000+00:00'),
    });
  };

  const setStartDate = (value: Date) => {
    setFilter({ ...filter, startDate: value });
  };

  const setEndDate = (value: Date) => {
    setFilter({ ...filter, endDate: value });
  };

  const selectedCompetition = (id: string, checked: boolean) => {
    const competitions = selectedFilterItems(
      id,
      checked,
      filter.selectedCompetitions
    );
    setFilter({ ...filter, selectedCompetitions: competitions });
  };

  const selectedAllCompetitions = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    let prizes = filter.competitions;
    if (checked) {
      const selectedCompetitions = prizes.reduce((acc, item) => {
        acc.push(item.id);
        return acc;
      }, Array<string>());
      setFilter({ ...filter, selectedCompetitions: selectedCompetitions });
    } else {
      setFilter({ ...filter, selectedCompetitions: Array<string>() });
    }
  };

  const applyCompetitionFilter = () => {
    getOrders(
      1,
      state.perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const clearSelectedFilter = () => {
    setFilter({ ...filter, selectedCompetitions: Array<string>() });
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ): void => {
    getOrders(
      newPage + 1,
      state.perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getOrders(
      page,
      state.perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const handleFirstPage = () => {
    getOrders(
      1,
      state.perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getOrders(
      1,
      perPage,
      state.field,
      state.order,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const handleSort = (direction: string, title: string) => {
    const field = getFieldByTitle(title);
    getOrders(
      state.page,
      state.perPage,
      field,
      direction,
      filter.selectedCompetitions,
      searchState[filter.searchField],
      filter.searchField,
      filter.startDate,
      filter.endDate
    );
  };

  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(' ');
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };

  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };

  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: '' });
  };

  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getOrders(
      1,
      10,
      '_id',
      'asc',
      filter.selectedCompetitions,
      searchState[field],
      field,
      filter.startDate,
      filter.endDate
    );
  };

  const toShowOrder = (ordersIds: Order) => {
    const orders = ordersIds ? ordersIds : undefined;
    setModal({ ...modal, viewTickets: true, orders: orders, isShow: true });
  };

  const toEditOrder = (ordersIds: Order) => {
    const orders = ordersIds ? ordersIds : undefined;
    setModal({ ...modal, viewTickets: true, orders: orders, isShow: false });
  };

  const openRemove = (ids: Array<string>) => {
    setModal({ ...modal, removeOrder: true, orderIds: ids });
  };

  const closeRemove = () => {
    setModal({ ...modal, removeOrder: false });
  };

  const removeOrder = async () => {
    const ids = modal.orderIds ? modal.orderIds : [];
    const result = await dataProvider.deleteMany('orders', { ids: ids });
    if (result.data) {
      notify('Order has been deleted', 'info');
      refresh();
    }
  };

  const closeFilter = (e: any) => {
    setDropdown({ competition: false, product: false, draw: false });
  };

  return (
    <>
      <Box marginTop='0.5em'>
        {!isShow && (
          <Box display='flex' justifyContent='flex-end' paddingBottom='14px'>
            <Button
              className='user-cancel-button user-modal-buttons'
              onClick={openAddTicketsModal}
            >
              Add Ticket
            </Button>
          </Box>
        )}
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id='active-table-head'>User</TableCell>
                  <TableCell id='active-table-head'>Email</TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Competition'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.competition && (
                      <FilterComponent
                        categories={filter.competitions}
                        selectedCategories={filter.selectedCompetitions}
                        handleSelectedCategory={selectedCompetition}
                        selectedAllCategories={selectedAllCompetitions}
                        clearCategory={clearSelectedFilter}
                        hideSearch={true}
                        appointment=''
                        applyCategoryFilter={applyCompetitionFilter}
                      />
                    )}
                  </TableCell>

                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Product'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.product && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, 'name')
                        }
                        applySearch={() => applySearch('name')}
                        searchString={searchState.name}
                        clearSearch={() => clearSearch('name')}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable title='Number of tickets' sort={handleSort} />
                  </TableCell>
                  <TableCell id='active-table-head'>
                    <HeadTable
                      title='Draw Date'
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.draw && (
                      <DateFilter
                        applyDateFilter={applyDateFilter}
                        clearDateFilter={clearDateFilter}
                        endDate={filter.endDate}
                        startDate={filter.startDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    )}
                  </TableCell>
                  <TableCell id='active-table-head-actions'>Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.orders.map((item) => {
                return (
                  <TableBody onClick={closeFilter}>
                    <TableCell>{`${item.userName} ${item.userSurname}`}</TableCell>
                    <TableCell>{`${
                      item.userEmail ? item.userEmail : '-'
                    }`}</TableCell>
                    <TableCell>{item.competition}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.ticketsCount}</TableCell>
                    <TableCell>{getDate(new Date(item.drawDate))}</TableCell>
                    <TableCell>
                      <div className='actions-table-body'>
                        <VisibilityIcon
                          onClick={() => toShowOrder(item)}
                          id='show-tickets'
                        />
                        {!isShow && (
                          <>
                            <EditIcon
                              onClick={() => toEditOrder(item)}
                              id='show-tickets'
                            />
                            <div onClick={() => openRemove(item.ordersIds)}>
                              <DeleteForeverIcon className='delete-icon' />
                            </div>
                          </>
                        )}
                      </div>
                    </TableCell>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.orders.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title='Users'
          />
          <Dialog
            fullWidth
            open={modal.addTickets}
            onClose={closeAddTicketsModal}
            id='add-tickets-dialog'
          >
            {/* <DialogContent>
                <AddTickets closeModal={closeAddTicketsModal} id={id} />
              </DialogContent> */}
          </Dialog>
          <Dialog
            fullScreen
            fullWidth
            open={modal.viewTickets}
            onClose={closeViewTickets}
            id='show-tickets-dialog'
          >
            <DialogContent>
              <ViewTickets
                order={modal.orders}
                userId={id}
                isShow={modal.isShow}
              />
            </DialogContent>
          </Dialog>
          <Dialog open={modal.removeOrder} onClose={closeRemove}>
            <DialogContent>
              <RemoveItem
                closeModal={closeRemove}
                removeUser={removeOrder}
                mainText='orders'
                minorText=''
              />
            </DialogContent>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default UsersTab;
